import React, { useState, useContext } from 'react';
import { Modal, Button, Checkbox } from 'antd';

import background_circle_green from 'images/background_circle_green_modal.svg';
import icons_arrow_left_right from 'images/icons_arrow_left_right.svg';

import icon_arrow_left_bgc_dark from 'images/icon_arrow_left_bgc_dark.svg';
import icon_arrow_right_bgc_dark from 'images/icon_arrow_right_bgc_dark.svg';
import click_here_to_exit from 'images/modal/click_here_to_exit.svg';
import icon_close from 'images/modal/icon_close.svg';
import nav_left_myproject from 'images/modal/nav_left_myprojects.svg';
import nav_left_stats from 'images/modal/nav_left_stats.svg';
import nav_left_transform from 'images/modal/nav_left_transform.svg';
import { AppContext } from 'context/AppContext';

// import { useNavigate } from "react-router-dom";

const MyProjects = () => {
    // const navigate = useNavigate()
    let appContext = useContext(AppContext);

    const [isModalVisibleMyProjects, setIsModalVisibleMyProjects] =
        useState(true);

    const [isModalVisibleStats, setIsModalVisibleStats] = useState(false);
    const [isModalVisibleTransform, setIsModalVisibleTransform] =
        useState(false);
    const [isModalVisibleHelp, setIsModalVisibleHelp] = useState(false);

    const showModalMyProjects = () => {
        setIsModalVisibleMyProjects(true);
    };

    const handleOkMyProjects = () => {
        setIsModalVisibleMyProjects(false);
        setIsModalVisibleStats(true);
    };

    const handleBackMyProjects = () => {
        setIsModalVisibleMyProjects(false);
    };

    const handleCancelMyProjects = () => {
        setIsModalVisibleMyProjects(false);
    };

    const showModalStats = () => {
        setIsModalVisibleStats(true);
    };

    const handleOkStats = () => {
        setIsModalVisibleStats(false);
        setIsModalVisibleTransform(true);
    };

    const handleBackStats = () => {
        setIsModalVisibleStats(false);
        setIsModalVisibleMyProjects(true);
    };

    const handleCancelStats = () => {
        setIsModalVisibleStats(false);
    };

    const showModalTransform = () => {
        setIsModalVisibleTransform(true);
    };

    const handleOkTransform = () => {
        setIsModalVisibleTransform(false);
        setIsModalVisibleHelp(true);
    };

    const handleBackTransform = () => {
        setIsModalVisibleTransform(false);
        setIsModalVisibleStats(true);
    };

    const handleCancelTransform = () => {
        setIsModalVisibleTransform(false);
    };

    // const handleBackHelp = () => {
    // }

    const showModalHelp = () => {
        setIsModalVisibleHelp(true);
    };

    const handleOkHelp = () => {
        setIsModalVisibleHelp(false);
        appContext.setDefault('onboarding_home', 'finish');
    };

    const handleBackHelp = () => {
        setIsModalVisibleHelp(false);
        setIsModalVisibleTransform(true);
    };

    const handleCancelHelp = () => {
        setIsModalVisibleHelp(false);
    };

    return (
        <>
            <Modal
                className="custom-modal-tutorial"
                visible={isModalVisibleMyProjects}
                onOk={handleOkMyProjects}
                onCancel={handleCancelMyProjects}
                footer={null}
                closable={false}
                bodyStyle={{ height: 'auto' }}
                width={302}
            >
                <div className="tutorial-container">
                    {/* <div className="nav-left">
                        <img src={nav_left_myproject} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">My projects</div>
                        <div className="icon-close">
                            <img
                                onClick={handleCancelMyProjects}
                                src={icon_close}
                            />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            All of your previously uploaded data <br />
                            sets are kept here. This is also <br />
                            where you can upload your own set <br />
                            of data.
                        </div>
                        <div className="description">
                            You can also turn data sets into <br />
                            smaller sample sets here.
                        </div>
                    </div>
                    <div className="footer">
                        {/* <div
                            className="button-prev"
                            onClick={() => {
                                handleBackMyProjects();
                            }}
                        >
                            BACK
                        </div> */}
                        <div
                            style={{ width: '90px', marginLeft: '12px' }}
                        ></div>
                        <div className="step">Step 1 of 4</div>
                        <div
                            onClick={handleOkMyProjects}
                            className="button-next"
                        >
                            NEXT
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                className="custom-modal-tutorial-stats"
                visible={isModalVisibleStats}
                onOk={handleOkStats}
                onCancel={handleCancelStats}
                footer={null}
                closable={false}
                bodyStyle={{ height: 'auto' }}
                width={302}
            >
                <div className="tutorial-container-stats">
                    {/* <div className="nav-left">
                        <img src={nav_left_stats} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Stats</div>
                        <div className="icon-close">
                            <img onClick={handleCancelStats} src={icon_close} />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            Here is where you can perform <br />
                            different types of analysis.
                        </div>
                        <div className="description">
                            Previously applied analyses can be <br />
                            viewed, edited and exported from <br />
                            here.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackStats();
                            }}
                        >
                            BACK
                        </div>
                        <div className="step">Step 2 of 4</div>
                        <div onClick={handleOkStats} className="button-next">
                            NEXT
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                className="custom-modal-tutorial-transform"
                visible={isModalVisibleTransform}
                onOk={handleOkTransform}
                onCancel={handleCancelTransform}
                footer={null}
                closable={false}
                bodyStyle={{ height: 'auto' }}
                width={302}
            >
                <div className="tutorial-container-transform">
                    {/* <div className="nav-left">
                        <img src={nav_left_transform} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Transform</div>
                        <div className="icon-close">
                            <img
                                onClick={handleCancelTransform}
                                src={icon_close}
                            />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            Use this function to transform <br />
                            variables and add them to the data <br />
                            frame.
                        </div>
                        <div className="description">
                            Numerical and categorical {'('}Pro{')'} <br />
                            transformations are available.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackTransform();
                            }}
                        >
                            BACK
                        </div>
                        <div className="step">Step 3 of 4</div>
                        <div
                            onClick={handleOkTransform}
                            className="button-next"
                        >
                            NEXT
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                className="custom-modal-tutorial-help"
                visible={isModalVisibleHelp}
                onOk={handleOkHelp}
                onCancel={handleCancelHelp}
                footer={null}
                closable={false}
                bodyStyle={{ height: 'auto' }}
                width={302}
            >
                <div className="tutorial-container-help">
                    {/* <div className="nav-left">
                        <img src={nav_left_transform} />
                    </div> */}
                    <div className="buddle-left"></div>
                    <div className="header">
                        <div className="title">Help</div>
                        <div className="icon-close">
                            <img onClick={handleCancelHelp} src={icon_close} />
                        </div>
                    </div>
                    <div className="body">
                        <div className="description">
                            These tips can be found here along <br />
                            with the rest of the help section.
                        </div>
                    </div>
                    <div className="footer">
                        <div
                            className="button-prev"
                            onClick={() => {
                                handleBackHelp();
                            }}
                        >
                            BACK
                        </div>
                        <div className="step">Step 4 of 4</div>
                        <div onClick={handleOkHelp} className="button-next">
                            FINISH
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default MyProjects;
